import { ICreateCsvPayload } from '../hooks/interfaces/ICreateCsvPayload';
import axiosSingleton from './axios';

export const createCSVApi = async (payload: ICreateCsvPayload) => {
  return axiosSingleton.post('CreateCsv', payload);
}